import { authenticationService } from '@/services/authentication';

function parseCognitoGroups(raw: unknown): string[] {
  if (Array.isArray(raw)) {
    return raw.map(String).map(group => group.trim()).filter(Boolean);
  }

  if (typeof raw !== 'string') {
    return [];
  }

  const trimmed = raw.trim();
  if (!trimmed) {
    return [];
  }

  if (trimmed.startsWith('[')) {
    try {
      const parsed = JSON.parse(trimmed) as unknown;
      if (Array.isArray(parsed)) {
        return parsed.map(String).map(group => group.trim()).filter(Boolean);
      }
    } catch {
      /* fallback para CSV */
    }
  }

  return trimmed
    .split(',')
    .map(group => group.trim())
    .filter(Boolean);
}

export async function getUserCognitoGroups(): Promise<string[]> {
  try {
    const session = await authenticationService.getAuthSession();
    if (!session) return [];

    return parseCognitoGroups(session.payload['cognito:groups']);
  } catch (error) {
    console.error('Erro ao obter grupos Cognito:', error);
    return [];
  }
}
